import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../apiService';
import './Login.css';

// Mock fallback for demo when backend has no data
const MOCK_USER = {
  email: 'test@zibit.com',
  password: 'password123'
};

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Try real API first
      const result = await loginUser(email, password);
      
      if (result.success) {
        localStorage.setItem('token', result.token);
        localStorage.setItem('user', JSON.stringify(result.user));
        navigate('/dashboard');
      } else {
        // Fallback to mock for demo if backend fails
        if (email === MOCK_USER.email && password === MOCK_USER.password) {
          localStorage.setItem('token', 'demo-token');
          localStorage.setItem('user', JSON.stringify({
            name: 'Demo User',
            email: email
          }));
          navigate('/dashboard');
        } else {
          setError(result.error || 'Invalid credentials. Try test@zibit.com / password123 for demo.');
        }
      }
    } catch (err) {
      // If API call fails completely, use mock
      if (email === MOCK_USER.email && password === MOCK_USER.password) {
        localStorage.setItem('token', 'demo-token');
        localStorage.setItem('user', JSON.stringify({
          name: 'Demo User',
          email: email
        }));
        navigate('/dashboard');
      } else {
        setError('Backend unavailable. Use test@zibit.com / password123 for demo.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>Welcome to Zibit</h1>
        <p className="login-subtitle">Sign in to your account</p>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@example.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
            />
          </div>

          <button type="submit" disabled={loading} className="login-button">
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="test-credentials">
          Demo: test@zibit.com / password123
        </p>
      </div>
    </div>
  );
}

export default Login;